import { includes, findIndex, size } from "lodash"

export const ASC = "asc"
export const DESC = "desc"

export const FOUR_WAY_SORT_ORDERS = ["asc", "desc", "ascAbs", "descAbs"]

const TWO_WAY_SORT = [{
  direction: DESC,
}, {
  direction: ASC,
}]

const FOUR_WAY_SORT = [
  ...TWO_WAY_SORT,
  {
    direction: DESC,
    absolute: true,
  }, {
    direction: ASC,
    absolute: true,
  }]

export function getNextSort(currentSort, allowAbsolute) {
  const sorts = allowAbsolute ? FOUR_WAY_SORT : TWO_WAY_SORT
  const currentSortIndex = findIndex(sorts, sortItem =>
    sortItem.direction === currentSort.direction && sortItem.absolute === currentSort.absolute,
  )

  if (currentSortIndex === -1 || currentSortIndex === size(sorts) - 1) {
    return sorts[0]
  }

  return sorts[currentSortIndex + 1]
}

export const orderState = (by, initialDir, fourWayExcluded = ["name"]) => ({
  by,
  dir: initialDir,
  abs: false,
  fourWayExcluded,
})

export const sortDirLabel = ({ dir, abs, alphabetical = false }) => {
  if (alphabetical) {
    return dir === ASC ? "Sorted A-Z" : "Sorted Z-A"
  }
  if (dir === ASC) return abs ? "Sorted low to high magnitude" : "Sorted negative to positive"
  return abs ? "Sorted high to low magnitude" : "Sorted positive to negative"
}

export const handleSort = (state, { order: { by, current } }) => {
  if (by !== current.by) {
    return {
      ...state,
      order: { ...current, by, dir: DESC, abs: false },
    }
  }

  const orderUpdates = {
    dir: current.dir === ASC ? DESC : ASC,
  }

  const handle4WaySort = !includes(current.fourWayExcluded, by)
  if (handle4WaySort && current.dir === ASC) {
    orderUpdates.abs = !current.abs
  }

  return {
    ...state,
    order: {
      ...current,
      ...orderUpdates,
    },
  }
}

export function parseSortOrder(order) {
  const len = order.length
  if (len > DESC.length) {
    return [order.substr(0, len - "Abs".length), true]
  }
  return [order, false]
}
